<div class="benefit-card" style="background-image: url('{{image}}')">
  <div class="content" style="background: {{background}}">
    <h3>{{title}}</h3>
    <a (click)="navigate(url)">Solicitar<fa-icon [icon]="faAngleRight"></fa-icon></a>
  </div>
</div>
